export const REDUCER_KEY = 'counterOfferFlights';
